var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-section" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        attrs: {
          "element-loading-text": "加载订单数据中...",
          "element-loading-spinner": "el-icon-loading",
          "element-loading-background": "rgba(255,255,255,0.85)",
        },
      },
      [
        !_vm.loading
          ? [
              _c(
                "el-table",
                {
                  staticStyle: {
                    width: "100%",
                    "margin-bottom": "20px",
                    "font-size": "14px",
                  },
                  attrs: {
                    data: _vm.contractList,
                    "max-height": _vm.tableHeight,
                    "header-cell-style": {
                      backgroundColor: "#e8eaed",
                      color: "#333",
                      fontSize: "14px",
                    },
                    "cell-style": { paddingBottom: "8px", paddingTop: "8px" },
                    border: "",
                    "row-key": "id",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "custName",
                      label: "客户姓名",
                      "min-width": "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "custMobile",
                      label: "客户电话",
                      "min-width": "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "custAddress",
                      label: "客户地址",
                      "min-width": "200",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "contractNo",
                      label: "合同号",
                      "min-width": "160",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "productionOrder",
                      label: "订单号",
                      "min-width": "180",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "solutionName",
                      label: "产品名称",
                      "min-width": "180",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "stoneMaterial",
                      label: "石材材料",
                      "min-width": "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "stoneColor",
                      label: "石材颜色",
                      "min-width": "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "stoneLength",
                      label: "石材米",
                      "min-width": "80",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "isAll",
                      label: "入库状态",
                      "min-width": "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "inTime",
                      label: "齐套日期",
                      "min-width": "180",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "area", label: "面积", "min-width": "80" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "体积", "min-width": "80" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    scope.row.vol != null ? scope.row.vol : "-"
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1840844585
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "packages",
                      label: "总包数",
                      "min-width": "80",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "入库数", "min-width": "80" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    scope.row.inPackages != null
                                      ? scope.row.inPackages
                                      : "-"
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3477781353
                    ),
                  }),
                  _vm._v(" "),
                  _vm.deliveryType === "配送(到家)" ||
                  _vm.deliveryType === "配送(到物流点)"
                    ? _c(
                        "el-table-column",
                        {
                          attrs: { "min-width": "140" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm.editable
                                      ? _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              error: _vm.getCommissionError(
                                                scope.row,
                                                "deliveryCommission"
                                              ),
                                              "label-width": "0",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "请输入",
                                                size: "small",
                                                type: "number",
                                                min: 0,
                                              },
                                              on: {
                                                change: function (v) {
                                                  if (v < 0 || v === "") {
                                                    scope.row.deliveryCommission =
                                                      null
                                                  }
                                                  _vm.$emit(
                                                    "commission-change",
                                                    scope.row,
                                                    "deliveryCommission"
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  scope.row.deliveryCommission,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "deliveryCommission",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "scope.row.deliveryCommission",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.deliveryCommission !=
                                                null
                                                ? scope.row.deliveryCommission
                                                : "-"
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2838825785
                          ),
                        },
                        [
                          _c("template", { slot: "header" }, [
                            _c("span", [_vm._v("送货提成")]),
                          ]),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.deliveryType === "配送(到家)" ||
                  _vm.deliveryType === "配送(到物流点)"
                    ? _c(
                        "el-table-column",
                        {
                          attrs: { "min-width": "160" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm.editable
                                      ? _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              error: _vm.getCommissionError(
                                                scope.row,
                                                "bigHomeInstallCommission"
                                              ),
                                              "label-width": "0",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "请输入",
                                                size: "small",
                                                type: "number",
                                                min: 0,
                                              },
                                              on: {
                                                change: function (v) {
                                                  if (v < 0 || v === "") {
                                                    scope.row.bigHomeInstallCommission =
                                                      null
                                                  }
                                                  _vm.$emit(
                                                    "commission-change",
                                                    scope.row,
                                                    "bigHomeInstallCommission"
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  scope.row
                                                    .bigHomeInstallCommission,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "bigHomeInstallCommission",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "scope.row.bigHomeInstallCommission",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row
                                                .bigHomeInstallCommission !=
                                                null
                                                ? scope.row
                                                    .bigHomeInstallCommission
                                                : "-"
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1728030969
                          ),
                        },
                        [
                          _c("template", { slot: "header" }, [
                            _c("span", [_vm._v("大家居安装提成")]),
                          ]),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pagination" },
      [
        _c("el-pagination", {
          attrs: {
            "current-page": _vm.currentPage,
            "page-sizes": [10, 20, 50, 100],
            "page-size": _vm.pageSize,
            layout: "total, sizes, prev, pager, next, jumper",
            total: _vm.total,
          },
          on: {
            "size-change": function ($event) {
              return _vm.$emit("size-change", $event)
            },
            "current-change": function ($event) {
              return _vm.$emit("current-change", $event)
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _c("span", [_vm._v("订单信息")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }